// @flow
import React, { Fragment } from 'react';
import { Applications } from '@finect/front-applications';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { ViewRiskProfile } from './partials';
import { Health } from './components';

type Props = {
  user: Object,
  actions: Object,
  match: Object
};

type State = {
  app: Object,
  integrations: Array<Object>
};

const mapStateToProps = state => ({
  user: state.user.user
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({}, dispatch)
});

// TODO: Deprecated
const app = new Applications('salud-financiera');

class Panel extends React.Component<Props, State> {
  state = {
    app: {},
    integrations: []
  };

  fetchHealthApp = () => {
    app.status = 'uncompleted';
    app.get(
      null,
      () => {
        app.fetched = true;
        this.setState({ app });
      },
      () => {
        app.fetched = true;
        this.setState({ app });
      }
    );
  };

  componentDidMount() {
    this.fetchHealthApp();
  }

  render() {
    if (!this.props.user) return null;

    return (
      <Fragment>
        <Health app={app} user={this.props.user} onResults={this.fetchHealthApp} />
        <ViewRiskProfile user={this.props.user} />
      </Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Panel);
